import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../topic/redux/actions';
import StyleTwoSectionTitle from './StyleTwoSectionTitle'

export class StyleTwoPrecent extends Component {
  static propTypes = {
    topic: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    let { itemsData } = this.props;
    return (
      <div className="topic-style-two-precent" style={{ height: `${itemsData.height}`, background: `url(${itemsData.totalbackImg}) no-repeat` }}>
        <a name={itemsData.name}><StyleTwoSectionTitle isColorW={false} Data={itemsData} /></a>
        <div className='subtitle_img'>
          <img src={itemsData.subtitleImg} alt="" />
          <div className='content_box flex_row'>
            {itemsData.list && itemsData.list.map(item => <div className='percent_content_item' key={item.id}>
              <div className='percent_header'>
                <div>{item.title}</div>
                <div className='percent_background' style={{ background: `url(${item.titleMask}) no-repeat` }}></div>
              </div>
              <div className='percent_content flex_row'>
                <div className='percent_posi_left'>
                  <div className='first_posi_tips flex_row'>百分网</div>
                  <div className='second_posi_tips flex_row'>自学</div>
                </div>
                <div className='percent_posi_right'>
                  <img src={item.showImg} alt=""/>
                  <div className='percent_posi_mask'>
                    <div className={item.id === 1 ? 'first_mask_text yellow' : 'first_mask_text white'}>{item.first_posi_title}</div>
                    <div className='second_mask_text'>{item.second_posi_title}</div>
                  </div>
                </div>
              </div>
              <div className='percent_footer'>
                {item.subtitle}
              </div>
            </div>)}
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleTwoPrecent);



// WEBPACK FOOTER //
// ./src/features/style-two/StyleTwoPrecent.js